import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell
} from 'recharts';
import { Loader2 } from 'lucide-react';
import { fetchData, deleteData, activateData } from '../../apiService';
import { useAuth } from '../../AuthContext';

const SalesPaymentStatusChart = () => {
    const [data, setData] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    useEffect(() => {
        const fetchSalesData = async () => {

            // Get current date
            const toDateObj = new Date();
            const toDate = toDateObj.toISOString().split('T')[0]; // Format: YYYY-MM-DD

            // Get date of same day previous month
            const fromDateObj = new Date(toDateObj);
            fromDateObj.setMonth(fromDateObj.getMonth() - 1);
            const fromDate = fromDateObj.toISOString().split('T')[0];

            try {
                const response = await fetchData('ReportApi', `/SalesCategoryWise/${fromDate}/${toDate}/${companyId}`, token);
                if (response.responseCode === '1111') {
                    //setDataItem(response.response_data);
                    const top10 = [...response.response_data]
                        .sort((a, b) => b.SaleQuantity - a.SaleQuantity)
                        .slice(0, 10);
                    setData(top10);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching sales data:', error);
            }
        };


        const fetchSalesPaymentStatus = async () => {
            const toDateObj = new Date();
            const toDate = toDateObj.toISOString().split('T')[0];

            const fromDateObj = new Date(toDateObj);
            fromDateObj.setMonth(fromDateObj.getMonth() - 1);
            const fromDate = fromDateObj.toISOString().split('T')[0];

            try {
                const response = await fetchData(
                    'ReportApi',
                    `/SalesPaymentStatus/${fromDate}/${toDate}/${companyId}`,
                    token
                );

                if (response.responseCode === '1111') {
                    const data = response.response_data;

                    if (data.length > 0) {
                        const { SaleAmount, PaidAmount } = data[0]; // Assuming only one object
                        const unpaid = SaleAmount - PaidAmount;

                        const chartData = [
                            { name: 'Paid', value: PaidAmount },
                            { name: 'Unpaid', value: unpaid }
                        ];

                        setSummaryData(chartData);
                        setLoading(false);
                    }
                }
            } catch (error) {
                console.error('Error fetching sales data:', error);
            }
        };


        fetchSalesData();
        fetchSalesPaymentStatus();
    }, []);

    return (
        // <div
        //     className="max-w-6xl mx-auto px-4"
        //     style={{
        //         fontFamily: 'monospace',
        //         color: '#1A1A1D',
        //         marginTop: '5px',
        //     }}
        // >
        //     {loading ? (
        //         <div className="flex justify-center items-center h-48 text-gray-500">
        //             <Loader2 className="animate-spin h-8 w-8 mr-2 text-blue-500" />
        //             Loading chart...
        //         </div>
        //     ) : (
        //         <div className="flex flex-col md:flex-row gap-4" style={{ width: '100%' }}>

        //             <div className="w-full md:w-3/3 bg-white rounded-xl shadow p-4">

        //                 <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>

        //                     <div style={{ flex: 1, height: 205 }}>
        //                         <h5
        //                             className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2"
        //                             style={{
        //                                 fontSize: '14px',
        //                                 fontFamily: 'monospace',
        //                                 color: '#1A1A1D',
        //                                 textTransform: 'uppercase',
        //                             }}
        //                         >
        //                             Sales Payment Status(Last 1 Month)
        //                         </h5>

        //                         <ResponsiveContainer width="100%" height="100%">
        //                             <PieChart>
        //                                 <Tooltip
        //                                     contentStyle={{
        //                                         fontSize: '12px',
        //                                         fontFamily: 'monospace',
        //                                         backgroundColor: '#f9fafb',
        //                                         borderRadius: '4px',
        //                                         border: '1px solid #d1d5db',
        //                                     }}
        //                                 />
        //                                 <Pie
        //                                     data={summaryData} 
        //                                     dataKey="value"
        //                                     nameKey="name"
        //                                     cx="50%"
        //                                     cy="50%"
        //                                     outerRadius={60}
        //                                     innerRadius={30}
        //                                     label={({ name, percent }) =>
        //                                         `${name} (${(percent * 100).toFixed(0)}%)`
        //                                     }
        //                                     style={{ fontSize: '10px', fontWeight: 'bold' }}
        //                                 >
        //                                     <Cell fill="#64748b" />
        //                                     <Cell fill="#1e3a8a" />
        //                                 </Pie>
        //                             </PieChart>
        //                         </ResponsiveContainer>
        //                     </div>

        //                     <div style={{ flex: 1, height: 205 }}>
        //                         <h5
        //                             className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2"
        //                             style={{
        //                                 fontSize: '14px',
        //                                 fontFamily: 'monospace',
        //                                 color: '#1A1A1D',
        //                                 textTransform: 'uppercase',
        //                                 marginLeft: '100px'
        //                             }}
        //                         >
        //                             Stock Position
        //                         </h5>

        //                         <ResponsiveContainer width="100%" height="100%">
        //                             <PieChart>
        //                                 <Tooltip
        //                                     contentStyle={{
        //                                         fontSize: '12px',
        //                                         fontFamily: 'monospace',
        //                                     }}
        //                                 />
        //                                 <Pie
        //                                     data={summaryData}
        //                                     dataKey="value"
        //                                     nameKey="name"
        //                                     cx="50%"
        //                                     cy="50%"
        //                                     outerRadius={60}
        //                                     label={({ name, percent }) =>
        //                                         `${name} (${(percent * 100).toFixed(0)}%)`
        //                                     }
        //                                     style={{ fontSize: '9px', fontWeight: 'bold' }}
        //                                 >
        //                                     <Cell fill="#4ade80" />
        //                                     <Cell fill="#f87171" />
        //                                 </Pie>
        //                             </PieChart>
        //                         </ResponsiveContainer>
        //                     </div>
        //                 </div>

        //             </div>
        //         </div>
        //     )
        //     }
        // </div >

        <div
            className="max-w-6xl mx-auto px-4 mt-4 font-mono text-[#1A1A1D]"
        >
            {loading ? (
                <div className="flex justify-center items-center h-48 text-gray-500">
                    <Loader2 className="animate-spin h-8 w-8 mr-2 text-blue-500" />
                    Loading chart...
                </div>
            ) : (
                <div className="flex flex-col md:flex-row gap-4 w-full">
                    {/* Sales Payment Status */}
                    <div className="flex-1 rounded-xl p-4">
                        <div style={{ flex: 1, height: 205 }}>
                            <h5
                                className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2"
                                style={{
                                    fontSize: '14px',
                                    fontFamily: 'monospace',
                                    color: '#1A1A1D',
                                    textTransform: 'uppercase',
                                }}
                            >
                                Sales Payment Status(Last 1 Month)
                            </h5>

                            {/* <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Tooltip
                                        contentStyle={{
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            
                                            borderRadius: '4px',
                                            border: '1px solid #d1d5db',
                                        }}
                                    />
                                    <Pie
                                        data={summaryData}
                                        dataKey="value"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={60}
                                        innerRadius={30}
                                        label={({ name, percent }) =>
                                            `${name} (${(percent * 100).toFixed(0)}%)`
                                        }
                                        style={{ fontSize: '10px', fontWeight: 'bold' }}
                                    >
                                        <Cell fill="#0b2d4f" /> 
                                        <Cell fill="#f6a623" /> 
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer> */}
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <defs>
                                        {/* Animated gradient for Paid */}
                                        <linearGradient id="wavePaid" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" stopColor="#00b09b">
                                                <animate
                                                    attributeName="offset"
                                                    values="0;1;0"
                                                    dur="3s"
                                                    repeatCount="indefinite"
                                                />
                                            </stop>
                                            <stop offset="100%" stopColor="#96c93d">
                                                <animate
                                                    attributeName="offset"
                                                    values="1;0;1"
                                                    dur="3s"
                                                    repeatCount="indefinite"
                                                />
                                            </stop>
                                        </linearGradient>

                                        {/* Animated gradient for Unpaid */}
                                        <linearGradient id="waveUnpaid" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" stopColor="#ff512f">
                                                <animate
                                                    attributeName="offset"
                                                    values="0;1;0"
                                                    dur="3s"
                                                    repeatCount="indefinite"
                                                />
                                            </stop>
                                            <stop offset="100%" stopColor="#dd2476">
                                                <animate
                                                    attributeName="offset"
                                                    values="1;0;1"
                                                    dur="3s"
                                                    repeatCount="indefinite"
                                                />
                                            </stop>
                                        </linearGradient>
                                    </defs>

                                    <Tooltip
                                        contentStyle={{
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            borderRadius: '4px',
                                            border: '1px solid #d1d5db',
                                        }}
                                    />

                                    <Pie
                                        data={summaryData}
                                        dataKey="value"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={60}
                                        innerRadius={30}
                                        label={({ name, percent }) =>
                                            `${name} (${(percent * 100).toFixed(0)}%)`
                                        }
                                        isAnimationActive={true}
                                        animationDuration={1000}
                                        style={{ fontSize: '10px', fontWeight: 'bold' }}
                                    >
                                        <Cell fill="url(#wavePaid)" />   {/* Paid - animated wave gradient */}
                                        <Cell fill="url(#waveUnpaid)" /> {/* Unpaid - animated wave gradient */}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>

                        </div>
                    </div>

                </div>
            )}
        </div >

    );

};

export default SalesPaymentStatusChart;
